module.exports = __webpack_public_path__ + "static/media/2C.2ebae580.svg";